import script from "./ChiTietNhapTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChiTietNhapTable.vue?vue&type=script&setup=true&lang=ts"

import "./ChiTietNhapTable.vue?vue&type=style&index=0&id=b584528c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b584528c"]])

export default __exports__